import React, { Component } from 'react';
import { Navigate } from 'react-router-dom';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      error: null,
      errorInfo: null,
      statusCode: 500 // 기본값은 500
    };
  }

  static getDerivedStateFromError(error) {
    // 업로드 관련 에러는 ErrorBoundary에서 처리하지 않음
    if (error.message?.includes('Upload') || 
        error.message?.includes('EventSource') ||
        error.message?.includes('duplicate')) {
      return { hasError: false };
    }

    // 에러 상태 코드 확인
    let statusCode = 500; // 기본값
    
    if (error.status === 404 || error.message?.includes('not found')) {
      statusCode = 404;
    }
    
    // 다음 렌더링에서 폴백 UI가 보이도록 상태를 업데이트합니다.
    return {
      hasError: true,
      error: error,
      statusCode: statusCode
    };
  }

  componentDidCatch(error, errorInfo) {
    // 업로드 관련 에러는 컴포넌트에서 직접 처리하도록 함
    if (error.message?.includes('Upload') || 
        error.message?.includes('EventSource') ||
        error.message?.includes('duplicate')) {
      return;
    }

    // 에러 리포팅 서비스에 에러를 기록할 수도 있습니다.
    console.error("ErrorBoundary caught an error", error, errorInfo);
    this.setState({
      errorInfo: errorInfo
    });
  }

  render() {
    if (this.state.hasError) {
      // 에러 코드에 따라 다른 에러 페이지로 리다이렉트
      const errorPath = this.state.statusCode === 404 ? '/error404' : '/error500';
      return <Navigate to={errorPath} replace />;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
